import { render, staticRenderFns } from "./authorization.vue?vue&type=template&id=0361c360&scoped=true&"
import script from "./authorization.vue?vue&type=script&lang=js&"
export * from "./authorization.vue?vue&type=script&lang=js&"
import style0 from "./authorization.vue?vue&type=style&index=0&id=0361c360&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361c360",
  null
  
)

export default component.exports